'use client';

import type { IEnglishIqItem } from '@repo/sdk';
import type { EnglishIqMessagesType } from '../../english-iq-messages-type';
import { EnglishIqChoiceAnswer } from './english-iq-choice-answer';
import { EnglishIqReorderAnswer } from './english-iq-reorder-answer';
import { EnglishIqTextAnswer } from './english-iq-text-answer';

interface IEnglishIqAnswerProps {
  disabled: boolean;
  item: IEnglishIqItem;
  messages: EnglishIqMessagesType['wizard'];
  onAnswer: (answer: string) => void;
}

export function EnglishIqAnswer({
  disabled,
  item,
  messages,
  onAnswer,
}: IEnglishIqAnswerProps): React.JSX.Element {
  if (item.type === 'choice') {
    return <EnglishIqChoiceAnswer disabled={disabled} item={item} onAnswer={onAnswer} />;
  }
  if (item.type === 'structured_input') {
    return (
      <div className="grid gap-4">
        <p className="text-lg font-semibold" dir="auto">
          {item.content.question}
        </p>
        <EnglishIqChoiceAnswer disabled={disabled} item={item} onAnswer={onAnswer} />
      </div>
    );
  }
  if (item.type === 'cloze') {
    return (
      <div className="grid gap-4">
        <p className="text-lg font-semibold" dir="ltr">
          {item.content.sentence}
        </p>
        {item.choices.length > 0 ? (
          <EnglishIqChoiceAnswer disabled={disabled} item={item} onAnswer={onAnswer} />
        ) : (
          <EnglishIqTextAnswer
            disabled={disabled}
            label={messages.answer}
            onAnswer={onAnswer}
            placeholder={messages.typeAnswer}
            submitLabel={messages.submit}
          />
        )}
      </div>
    );
  }
  if (item.type === 'reorder') {
    return (
      <EnglishIqReorderAnswer
        availableLabel={messages.availableParts}
        disabled={disabled}
        onAnswer={onAnswer}
        selectedLabel={messages.answer}
        submitLabel={messages.submit}
        tokens={item.content.tokens}
      />
    );
  }
  return (
    <div className="grid gap-4">
      <p className="text-lg font-semibold" dir="ltr">
        {item.content.sentence}
      </p>
      <p className="text-sm font-medium text-red-600 dark:text-red-300">
        {messages.mistake}: <bdi dir="ltr">{item.content.errorSpan}</bdi>
      </p>
      <EnglishIqTextAnswer
        disabled={disabled}
        label={messages.answer}
        onAnswer={onAnswer}
        placeholder={messages.typeAnswer}
        submitLabel={messages.submit}
      />
    </div>
  );
}
